var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackBarGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-292 -58)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.688 66h-3.376a.303.303 0 00-.312.296v7.408c0 .165.139.296.312.296h3.376a.303.303 0 00.312-.296v-7.408a.303.303 0 00-.312-.296z",
    fill: "#D6DCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.688 71h-3.376c-.173 0-.312.05-.312.11v2.78c0 .06.139.11.312.11h3.376c.173 0 .312-.05.312-.11v-2.78c0-.06-.139-.11-.312-.11z",
    fill: "#B1C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.688 58h-3.376a.318.318 0 00-.312.326v15.348c0 .181.139.326.312.326h3.376a.318.318 0 00.312-.326V58.326a.32.32 0 00-.312-.326z",
    fill: "#D6DCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.688 65h-3.376c-.173 0-.312.082-.312.184v8.632c0 .102.139.184.312.184h3.376c.173 0 .312-.082.312-.184v-8.632c0-.1-.139-.184-.312-.184z",
    fill: "#B1C2C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.688 74a.317.317 0 00.312-.325v-10.35a.317.317 0 00-.312-.325h-3.376a.317.317 0 00-.312.325v10.347c0 .18.139.325.312.325h3.376V74z",
    fill: "#D6DCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.688 74c.173 0 .312-.079.312-.177v-5.646c0-.098-.139-.177-.312-.177h-3.376c-.173 0-.312.079-.312.177v5.644c0 .098.139.177.312.177h3.376V74z",
    fill: "#B1C2C9"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#ECECEC",
    x: 142.5,
    y: 53.5,
    width: 173,
    height: 27,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackBarGray);
export default __webpack_public_path__ + "static/media/stack-bar-gray.63a33e1e072864dd85e966ee32381672.svg";
export { ForwardRef as ReactComponent };